import { render, staticRenderFns } from "./emergencyContactyzm.vue?vue&type=template&id=838fd200&scoped=true"
import script from "./emergencyContactyzm.vue?vue&type=script&lang=js"
export * from "./emergencyContactyzm.vue?vue&type=script&lang=js"
import style0 from "./emergencyContactyzm.vue?vue&type=style&index=0&id=838fd200&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838fd200",
  null
  
)

export default component.exports